import { HTTP } from "@/utils/http-common"
export default {
  get_gantt_data: function ($, companyId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`projects/company/${companyId}/gantt-admin`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
